import { Button } from "@progress/kendo-react-all";
import { Typography } from "@progress/kendo-react-common";
import { chevronLeftIcon } from "@progress/kendo-svg-icons";
import { StatusPage } from "@excent-one/react/layout";
import { useRouter } from "@tanstack/react-router";

const Forbidden = () => {
  const router = useRouter();

  return (
    <StatusPage code="403" title="Forbidden">
      <Typography.p>
        You do not have permission to access this page.
      </Typography.p>
      <Typography.p>
        Please contact your IT Administrator if you believe this is an error.
      </Typography.p>
      <Button
        fillMode="outline"
        size="large"
        svgIcon={chevronLeftIcon}
        onClick={() => router.history.back()}
      >
        Back to previous page.
      </Button>
    </StatusPage>
  );
};

export default Forbidden;
